import { userInfoStore } from '../../store/userInfoStore';

export const parseNumberByPrecision = (num1, num2, precision = 2, isForOdd = false) => {
  const re = new RegExp(`^-?\\d+(?:.\\d{0,${precision}})?`);
  const digitsAfterDotAtNum1 = num1.toString().split('.')[1]?.length || 0;
  const digitsAfterDotAtNum2 = num2.toString().split('.')[1]?.length || 0;
  const digitsCountAfterDot = digitsAfterDotAtNum2 + digitsAfterDotAtNum1;
  const numMulti =
    (Math.round(num1 * 10 ** digitsCountAfterDot) * Math.round(num2 * 10 ** digitsCountAfterDot)) /
    10 ** (digitsCountAfterDot + digitsCountAfterDot);
  return isForOdd
    ? +numMulti < 0.1 && +numMulti !== 0
      ? 0.1
      : +numMulti
    : +numMulti.toString().match(re) && +numMulti.toString().match(re)[0];
};

export const parseNumberPrecisionByDoteCount = (num1 = 1, num2 = 1, precision = 2) => {
  precision = userInfoStore.rate < 0.01 ? 0 : precision;
  const p = 10 ** precision;
  return Math.trunc(num1 * num2 * p) / p;
};
